import { useUpdateProjectMutation } from '../../api';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useUpdateProject = (options: any) => {
  const { headerWithAuth } = useGetAccessToken();
  const { mutate } = useUpdateProjectMutation(headerWithAuth, options);

  return mutate;
};

export {
  useUpdateProject,
};
